// extracted by mini-css-extract-plugin
module.exports = {"ko-KR":"chip_ko-KR__9rcMj","impressionTrackingContainer":"chip_impressionTrackingContainer__OFTDd","chip":"chip_chip__7QMY6","chip__lines":"chip_chip__lines__Ftwb2"};